import { Injectable } from '@angular/core';
import { GlobalUtilService } from '@otas/core/services/global-util.service';
@Injectable()
export class FilesService {

    constructor(private globalUtilService: GlobalUtilService) { }

    readFile(filename: string, encoding = 'utf8'): Promise<any> {
        const fs = this.globalUtilService.fsInstance;

        return new Promise((resolve, reject) => {
            !!fs && fs.stat(filename, (fileNotFoundErr, stat) => {
                if (!!fileNotFoundErr) {
                    reject(fileNotFoundErr);
                } else {
                    !!fs && fs.readFile(filename, encoding, (readErr, fileData) => {
                        if (!!readErr) {
                            reject(readErr);

                        } else {
                            resolve(fileData);
                        }
                    });
                }

            });

        });
    }
    writeTofile(filename: string, data: any): Promise<any> {
        const fs = this.globalUtilService.fsInstance;
        return new Promise((resolve, reject) => {
            !!fs && fs.stat(filename, (fileNotFoundErr, stat) => {
                if (!!fileNotFoundErr) {
                    reject(fileNotFoundErr);
                } else {
                    !!fs && fs.writeFile(filename, data, (writeError) => {
                        if (!!writeError) {
                            reject(writeError);
                        } else {
                            resolve('success');
                        }
                    });
                }
            });
        });
    }
    updatePropertyFile(filename: string, data: any): Promise<any> {

        const fs = this.globalUtilService.fsInstance;
        console.log('fsIns', fs);
        return new Promise((resolve, reject) => {
            const entries = this.deflate(data, ''); // Convert the JSON structure into an array of strings
            console.log('entries >> ',entries);
            !!fs && fs.stat(filename, (fileNotFoundErr, stat) => {
                if (!!fileNotFoundErr) {
                    const writeStream = fs.createWriteStream(filename);
                    entries.forEach((entry) => {
                        console.log('entry >>> ',entry);
                        writeStream.write(entry.concat('\n'));
                    });
                    writeStream.end();
                    resolve('success');
                } else if (!!stat) {
                    fs.unlink(filename, (fileUnlinkError) => {
                        if (!!fileUnlinkError) {
                            reject(fileUnlinkError);
                        } else {
                            const writeStream = fs.createWriteStream(filename);
                            entries.forEach((entry) => {
                                console.log('entry >>>> ',entry);
                                writeStream.write(entry.concat('\n'));
                            });
                            writeStream.end();
                            resolve('success');
                        }
                    });

                }

            });

        });
    }
    deflate(json, prefix) {
        let result = [];
        const keys = Object.keys(json);
        keys.forEach((key) => {
            let _prefix;

            if (json[key] && typeof json[key] === 'object') {
                const _currPrefix = key.concat('.');
                _prefix = prefix ? prefix.concat(_currPrefix) : _currPrefix;
                result = result.concat(this.deflate(json[key], _prefix));
            } else {
                _prefix = prefix ? prefix.concat(key) : key;
                result.push(_prefix.concat('=').concat(json[key] || ''));
            }
        });

        return result;
    }
}
